import { render, staticRenderFns } from "./RadionButton.vue?vue&type=template&id=374c9cc6&scoped=true&"
import script from "./RadionButton.vue?vue&type=script&lang=js&"
export * from "./RadionButton.vue?vue&type=script&lang=js&"
import style0 from "./RadionButton.vue?vue&type=style&index=0&id=374c9cc6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "374c9cc6",
  null
  
)

export default component.exports